import { SeriesType } from "./SeriesType";

// Worker-safe SeriesTypeReading mapping (no React/TSX dependencies)
export const SeriesTypeReading: Record<SeriesType, string> = {
  [SeriesType.FlowRate]: "flowRate",
  [SeriesType.NetAccumulator]: "waterUsage",
  [SeriesType.NetEnergyAccumulator]: "netEnergyAccumulator",
  [SeriesType.TemperatureInlet]: "temperature",
  [SeriesType.TemperatureOutlet]: "temperature",
  [SeriesType.Temperature]: "temperature",
  [SeriesType.Humidity]: "humidity",
  [SeriesType.Co2]: "co2",
  [SeriesType.Light]: "light",
  [SeriesType.Pressure]: "pressure",
  [SeriesType.Power]: "power",
  [SeriesType.PowerPerSqm]: "powerPerSqm",
  [SeriesType.AmpHours]: "power",
  [SeriesType.PowerCost]: "power",
  [SeriesType.PowerCarbon]: "power",
  [SeriesType.Dewpoint]: "dewPoint",
  [SeriesType.Sound]: "sound",
  [SeriesType.SoundMax]: "soundMax",
  [SeriesType.MinCurrent]: "minCurrent",
  [SeriesType.MaxCurrent]: "maxCurrent",
  [SeriesType.Tvoc]: "tvoc",
  [SeriesType.MinTvoc]: "minTVOC",
  [SeriesType.MaxTvoc]: "maxTVOC",
  [SeriesType.Pm1]: "pm1",
  [SeriesType.Pm2_5]: "pm2_5",
  [SeriesType.Pm10]: "pm10",
  [SeriesType.Occupied]: "occupied",
  [SeriesType.Water]: "waterUsage",
  [SeriesType.Gas]: "gasUsage",
  [SeriesType.GasCost]: "gasUsageCost",
  [SeriesType.AverageCurrent]: "averageCurrent",
  [SeriesType.PowerFactor]: "powerFactor",
  [SeriesType.ReferenceVoltage]: "referenceVoltage",
  [SeriesType.Voltage]: "voltage",
  [SeriesType.MouldRisk]: "mouldRisk",
  [SeriesType.HealthScore]: "healthScore",
  [SeriesType.FootTraffic]: "inOutSum",
  [SeriesType.OccupancyPeopleCount]: "occupancy",
  [SeriesType.OccupancyRegionPeopleCount]: "count",
  [SeriesType.DwellTimeMax]: "dwellTime",
  [SeriesType.DwellTimeMean]: "dwellTime",
  [SeriesType.OccupancyTotalIn]: "totalIn",
  [SeriesType.OccupancyTotalOut]: "totalOut",
  [SeriesType.OccupancyEntryCount]: "occupiedEntryCount",
  [SeriesType.PositiveAccumulator]: "total",
  [SeriesType.PositiveEnergyAccumulator]: "totalPositiveEnergy",
  [SeriesType.NegativeEnergyAccumulator]: "totalNegativeEnergy",
  [SeriesType.GeneratedEnergy]: "generatedkWh",
  [SeriesType.ImportedEnergy]: "importedkWh",
  [SeriesType.ExportedEnergy]: "exportedkWh",
  [SeriesType.OccupiedPercentage]: "occupiedPercentage",
  [SeriesType.RegionOccupancy]: "regionOccupancy",
  [SeriesType.TotalWaterVolume]: "totalWaterVolume",
  [SeriesType.WaterTemperature]: "waterTemperature",
  [SeriesType.AmbientTemperature]: "ambientTemperature",
};
